import { create } from "zustand"
import { immer } from "zustand/middleware/immer"
import { AprovarFaturaStore, Condicao } from "@FN"

export const useAprovarFaturaStore = create<AprovarFaturaStore>()(
  immer((set) => ({
    fatura: { numtit: "", cond: { E4_CODIGO: "" }, vencimentos: [] },
    actions: {
      setNumtit: (numtit) =>
        set((state) => {
          state.fatura.numtit = numtit
        }),
      setCond: (cond: Condicao) =>
        set((state) => {
          state.fatura.cond = cond
        }),
      setVencimentos: (vencimentos) =>
        set((state) => {
          state.fatura.vencimentos = vencimentos
        }),
      reset: () =>
        set((state) => {
          state.fatura = { numtit: "", cond: { E4_CODIGO: "" }, vencimentos: [] }
        }),
    },
  }))
)
